import * as angular from "angular";

const VehiclesType = [
  'Acura',
  'Alfa Romeo',
  'AM General',
  'American Motors Corporation',
  'ASC Incorporated',
  'Aston Martin',
  'Audi',
  'Aurora Cars Ltd',
  'Autokraft Limited',
  'Avanti Motor Corporation',
  'Azure Dynamics',
  'Bentley',
  'Bertone',
  'Bill Dovell Motor Car Company',
  'Bitter Gmbh and Co. Kg',
  'BMW',
  'BMW Alpina',
  'Bugatti',
  'Buick',
  'BYD',
  'Cadillac',
  'CCC Engineering',
  'Chevrolet',
  'Chrysler',
  'CODA Automotive',
  'Consulier Industries Inc',
  'CX Automotive',
  'Dabryan Coach Builders Inc',
  'Dacia',
  'Daewoo',
  'Daihatsu',
  'Dodge',
  'E. P. Dutton, Inc.',
  'Eagle',
  'Environmental Rsch and Devp Corp',
  'Evans Automobiles',
  'Excalibur Autos',
  'Federal Coach',
  'Ferrari',
  'Fiat',
  'Fisker',
  'Ford',
  'General Motors',
  'Genesis',
  'Geo',
  'GMC',
  'Goldacre',
  'Grumman Allied Industries',
  'Grumman Olson',
  'Honda',
  'Hummer',
  'Hyundai',
  'Import Foreign Auto Sales Inc',
  'Import Trade Services',
  'Infiniti',
  'Isis Imports Ltd',
  'Isuzu',
  'J.K. Motors',
  'Jaguar',
  'JBA Motorcars, Inc.',
  'Jeep',
  'Kenyon Corporation Of America',
  'Kia',
  'Laforza Automobile Inc',
  'Lambda Control Systems',
  'Lamborghini',
  'Land Rover',
  'Lexus',
  'Lincoln',
  'London Coach Co Inc',
  'London Taxi',
  'Lotus',
  'Mahindra',
  'Maserati',
  'Maybach',
  'Mazda',
  'Mcevoy Motors',
  'McLaren Automotive',
  'Mercedes-Benz',
  'Mercury',
  'Merkur',
  'MINI',
  'Mitsubishi',
  'Mobility Ventures LLC',
  'Morgan',
  'Nissan',
  'Oldsmobile',
  'Pagani',
  'Panos',
  'Panoz Auto-Development',
  'Panther Car Company Limited',
  'PAS Inc - GMC',
  'PAS, Inc',
  'Peugeot',
  'Pininfarina',
  'Plymouth',
  'Pontiac',
  'Porsche',
  'Quantum Technologies',
  'Qvale',
  'Ram',
  'Red Shift Ltd.',
  'Renault',
  'Rolls-Royce',
  'Roush Performance',
  'Ruf Automobile Gmbh',
  'Saab',
  'Saleen',
  'Saleen Performance',
  'Saturn',
  'Scion',
  'Shelby',
  'smart',
  'Spyker',
  'SRT',
  'Sterling',
  'Subaru',
  'Superior Coaches Div E.p. Dutton',
  'Suzuki',
  'Tecstar, LP',
  'Tesla',
  'Texas Coach Company',
  'Toyota',
  'TVR Engineering Ltd',
  'Vector',
  'Vixen Motor Company',
  'Volga Associated Automobile',
  'Volkswagen',
  'Volvo',
  'VPG',
  'Wallace Environmental',
  'Yugo'

];

const colors = [
  'Black',
  'Blue',
  'Brown',
  'Burgundy',
  'Gold',
  'Gray',
  'Green',
  'Orange',
  'Purple',
  'Red',
  'Silver',
  'Tan',
  'Teal',
  'White',
  'Yellow'
];

const vehiclePricingTypes = [
  'PerDistUnit',
  'PerTask',
  'PerStop',
  'PerDay',
  'PerHour',
  'PerPricePlan'
];

const defaultVehicleType = 'PrivateCar';

angular
  .module('bringoz.admin.vehicles')
  .constant('VehiclesConstants', {
    makes: VehiclesType,
    colors: colors,
    vehiclePricingTypes: vehiclePricingTypes,
    defaultVehicleType: defaultVehicleType
  });
